import { defineComponent as _defineComponent } from 'vue'
import CardExpand from '@/views/components/CardExpand.vue';
import { mdiInformation } from '@mdi/js';
import AutocompleteGraphql from '@/views/components/autocompletes/AutocompleteGraphql.vue';
import { GET_CATEGORIAS, GET_MAGISTRADOS } from '@/queries';
import { ConsultaParecerStore } from '@/views/parecer/store/ConsultaParecerStore';
import { storeToRefs } from 'pinia';
import { onMounted, ref } from 'vue';
import { useLazyQuery } from '@vue/apollo-composable';


export default /*#__PURE__*/_defineComponent({
  __name: 'CardMaisFiltros',
  setup(__props) {

const store = ConsultaParecerStore();
const { filtroParecer } = storeToRefs(store);

const updateCount = ref(0);
const categoriaItems = ref([]);

onMounted(async () => {
  const getCategorias = useLazyQuery(GET_CATEGORIAS);
  getCategorias.variables.value = { deCategParecer: '' };
  await getCategorias.load();
  categoriaItems.value = getCategorias.result.value.categPareceres.map(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (cat: any) => ({ text: cat.deCategParecer, value: cat })
  );
});

return { __sfc: true,store, filtroParecer, updateCount, categoriaItems, CardExpand, mdiInformation, AutocompleteGraphql, GET_MAGISTRADOS }
}

})